import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTwitterLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_400_14515)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0 0H20V20H0V0Z",
			fill: "black"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.10121 4.62109H4.53503L8.76323 10.206L4.80552 14.8911H6.6341L9.62748 11.3476L12.2855 14.8585H15.8517L11.5006 9.11124L11.5083 9.12115L15.2546 4.68631H13.426L10.6439 7.97971L8.10121 4.62109ZM6.50351 5.5992H7.61371L13.8832 13.8804H12.773L6.50351 5.5992Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_400_14515",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 10,
			fill: "white"
		})
	}) })]
});
export default SvgTwitterLogo;
